import { inject, Injectable } from '@angular/core';
import {
  ActivatedRouteSnapshot,
  CanActivate,
  Router,
  RouterStateSnapshot,
  UrlTree,
} from '@angular/router';
import { first, map, Observable } from 'rxjs';
import { AuthService } from '../../services/auth';

@Injectable({
  providedIn: 'root',
})
export class AuthGuard implements CanActivate {
  router = inject(Router);
  authService = inject(AuthService);

  publicRoutes = {
    entrar: '/autenticacao/entrar',
    recuperarSenha: '/autenticacao/recuperar-senha',
    redefinirSenha: '/autenticacao/redefinir-senha',
  };

  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Observable<boolean | UrlTree> {
    return this.authService.isAuthenticated$.pipe(
      first(),
      map((isAuthenticated) => {
        const isPublicRoute = this.isPublicRoute(state);

        if (isAuthenticated && isPublicRoute) {
          return this.router.parseUrl('/dashboard');
        }

        if (isPublicRoute) {
          return true;
        }

        if (!isAuthenticated) {
          return this.router.parseUrl(this.publicRoutes.entrar);
        }

        return true;
      })
    );
  }

  private isPublicRoute(state: RouterStateSnapshot): boolean {
    return Object.values(this.publicRoutes).some((publicRoute) =>
      state.url.startsWith(publicRoute)
    );
  }
}
